import { ErrorPage } from "@fideus-ui/core";
import { createRouter, Navigate } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => <Navigate to="/" />,
  defaultErrorComponent: ({ error }) => <ErrorPage message={error.message} />,
  // Preload route data on hover/focus so navigations feel instant without eagerly loading all routes
  defaultPreload: "intent",
  // Preserve referential identity of search params across navigations to avoid unnecessary re-renders
  defaultStructuralSharing: true,
  // Restore scroll position on back/forward navigation to match native browser behavior in the SPA
  scrollRestoration: true,
  // biome-ignore lint/style/noNonNullAssertion: Following TanStack Router documentation recommendations
  context: { queryClient: undefined!, trpc: undefined!, config: undefined! },
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
